import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'lib-ags-kendo-window-titlebar',
  templateUrl: './kendo-window-titlebar.component.html',
  styleUrls: ['./kendo-window-titlebar.component.scss']
})
export class KendoWindowTitlebarComponent {
  @Output() output = new EventEmitter<boolean>();
  @Input('title')
  set _title(value: string) {
    this.title = value;
  }
  @Input('msgText')
  set _msgText(value: string) {
    this.msgText = value;
  }

  public title: string;
  public msgText: string;

  onClick() {
    this.output.emit(true);
  }
}
